module.exports = __webpack_public_path__ + "img/user_activiti.7dc03948.svg";